module.exports = __webpack_public_path__ + "images/5aff74e82449e45fae8bbcfe498ac3ba-nurse1.jpg";